import { Injectable } from '@angular/core';
import { MenuListDto, MenuList, MenuListPayload } from '../../models/system-settings/menu-lists.model';

@Injectable({
  providedIn: 'root',
})
export class MapperMenuListsService {
  // ================= Normal Functions =================

  constructor() { }

  /**
   * Maps a single MenuListDto to MenuList model.
   * @param dto MenuListDto from API
   */
  mapMenuListFromDto(dto: MenuListDto): MenuList {
    return {
      id: dto.id,
      name: dto.name || '',
      status: dto.status ?? false,
      path: dto.path || '',
      pathId: dto.pathId ?? null,
      number: dto.number || 0,
      groupMenuId: dto.groupMenuId || 0,
      groupMenuName: dto.groupMenuName || '',
      groupSubId: dto.groupSubId,
      groupSubName: dto.groupSubName,
      createDate: dto.createDate ? new Date(dto.createDate) : null,
      writeDate: dto.writeDate ? new Date(dto.writeDate) : null,
    };
  }

  /**
   * Maps a single MenuList model to MenuListDto payload. (Deprecated: Use mapMenuListToPayload instead for POST/PUT)
   * @param model MenuList model from UI
   */
  mapMenuListToDto(model: MenuList): MenuListDto {
    return {
      id: model.id,
      name: model.name,
      status: model.status,
      path: model.path,
      pathId: model.pathId ?? null,
      number: model.number,
      groupMenuId: model.groupMenuId,
      groupMenuName: model.groupMenuName,
      groupSubId: model.groupSubId,
      groupSubName: model.groupSubName,
      createDate: model.createDate ? model.createDate.toISOString() : null,
      writeDate: model.writeDate ? model.writeDate.toISOString() : null,
    };
  }

  /**
   * Maps a MenuList model to the payload format required by insertMenuList and updateMenuList APIs.
   * @param model MenuList model from UI
   * @param userId ID of the user performing the action
   * @param menuId ID of the menu page where the action occurs
   */
  mapMenuListToPayload(model: MenuList, userId: number, menuId: number): MenuListPayload {
    return {
      id: model.id,
      name: model.name,
      status: model.status,
      path: model.path,
      pathId: model.pathId ?? null,
      number: model.number,
      groupMenuId: model.groupMenuId,
      groupSubId: model.groupSubId,
      userId: userId,
      menuId: menuId
    };
  }
}
